<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: "primary"
    },
    textColor: {
      type: String,
      required: false,
      default: "white"
    },
    icon: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    description: {
      type: [String, Boolean],
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <v-tooltip v-if="description" open-delay="0" close-delay="0" right>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        @click="$emit('click')"
        small
        :color="color"
        :text-color="textColor"
      >
        <v-avatar :color="`${color}`" v-if="icon">
          <v-icon small>{{ icon }}</v-icon>
        </v-avatar>
        {{ status }}
      </v-chip>
    </template>

    <span>{{ description }}</span>
  </v-tooltip>

  <v-chip v-else small disabled :color="color" :text-color="textColor">
    <v-avatar :color="`${color}`" v-if="icon">
      <v-icon small>{{ icon }}</v-icon>
    </v-avatar>
    {{ status }}
  </v-chip>
</template>

<style scoped>
.v-chip {
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Status/Chip.vue